import React, { useState, useEffect } from "react";
import Card from "olive-react-myoneui/lib/Card";
import Tab from "olive-react-myoneui/lib/Tab";
import Nav from "olive-react-myoneui/lib/Nav";
import ApprenticeshipCarousel from "./CompletedApprenticeshipCarousel";
import MyCoursesCarousel from "./CompletedCoursesCarousel";
import Button from "olive-react-myoneui/lib/Button";
import { useSelector } from "react-redux";
import { checkDisabledSp } from "../../../../helpers/permission_helper";
// import NoItemsInfo from "./NoItemsInfo";

function CoursesApprenticeshipTabs({ className,  setHasError }) {
  const adminData = useSelector((state) => state.admin);
  const [eportfolioEnabled, setEportfolioEnabled] = useState(false);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const [showCertModal, setShowCertModal] = useState(false);

  const handleCloseModalCert = () => setShowCertModal(false);
  const handleShowCertModal = () => setShowCertModal(true);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const products = adminData.products ?? [];
    const isEportfolioEnabled = products.some(
      (value) => value.sp_slug === "eportfolio"
    );
    setEportfolioEnabled(isEportfolioEnabled);
   }, [adminData]);

  if(checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && !eportfolioEnabled) {
    return (
      <></>
    );
  }

  return (
    <Card className="course-tabs-carousel myk__completed_course-tabs-carousel border-0 mb-0">
      <Card.Body className="p-0 pb-0">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) ? 'apprenticeship' : 'enrolledcourses'}
        >
          <div className="myk__courses-tabs_actions-wrapper d-flex gap-2 justify-content-between">
            <Nav variant="pills" className="p-0">
              {
                !checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) &&
                <Nav.Item>
                  <Nav.Link eventKey="enrolledcourses">
                    Completed Courses
                  </Nav.Link>
                </Nav.Item> 
              }
              {eportfolioEnabled && (
                <Nav.Item>
                  <Nav.Link eventKey="apprenticeship">
                    Completed Apprenticeship
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
            {/* <div className="myk__courses-tabs-actions d-flex gap-2">
              <Button variant="outline" className="bg-transparent py-1">View All</Button>
            </div> */}
          </div>
          <Tab.Content>
            {
            !checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) &&
            <Tab.Pane
              eventKey="enrolledcourses"
              className="bg-transparent ps-0 pb-3"
            >
              <MyCoursesCarousel setHasError={setHasError}/>
              {/* <NoItemsInfo /> */}
            </Tab.Pane>
            }
            {
              eportfolioEnabled && (
              <Tab.Pane
                eventKey="apprenticeship"
                className="bg-transparent ps-0 pb-3"
              >
                <ApprenticeshipCarousel setHasError={setHasError}/>
                {/* <NoItemsInfo /> */}
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </Card.Body>
    </Card>
  );
}

export default CoursesApprenticeshipTabs;
